import { render, staticRenderFns } from "./createAccount.pug?vue&type=template&id=eecaaac0&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./createAccount.scss?vue&type=style&index=0&id=eecaaac0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eecaaac0",
  null
  
)

export default component.exports